import { Col, Row, Space, Table } from 'antd';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { EyeOutlined } from '@ant-design/icons';
import { ICourseCertificate } from 'interfaces/course_certificate';
import { ISignatures } from 'interfaces/signatures';
import { ListLayout } from '../../../components/layout/layout/ListLayout';

export const SignaturesList = () => {
  const { tableProps } = useTable<ISignatures>({});

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ListLayout title="Assinaturas">
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="name"
              key="name"
              title="Nome"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="title"
              key="title"
              title="Título"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex={['certifier', 'name']}
              key="certifier"
              title="Nome da instituição"
              render={value => <TextField value={value} />}
            />
            <Table.Column<ICourseCertificate>
              title="Ações"
              dataIndex="actions"
              align="center"
              width={100}
              render={(_, record) => {
                return (
                  <Space>
                    <EditButton
                      hideText
                      icon={<EyeOutlined />}
                      size="small"
                      recordItemId={record.id}
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </ListLayout>
      </Col>
    </Row>
  );
};
